import type { Appearance } from "../types";

export type AppearanceTableProps = { appearance: Appearance };
const labels: Record<keyof Appearance, string> = { heightCm: "키", weightKg: "몸무게", build: "체격", faceShape: "얼굴형", hairShape: "두발형태", hairColor: "머리색", clothing: "옷차림" };

export function AppearanceTable({ appearance }: AppearanceTableProps) {
  const rows = Object.entries(appearance).filter((entry): entry is [keyof Appearance, string | number] => entry[1] !== null && entry[1] !== undefined && entry[1] !== "");
  return rows.length ? <dl className="appearance-table">{rows.map(([key, value]) => <div key={key}><dt>{labels[key]}</dt><dd>{value}{key === "heightCm" ? "cm" : key === "weightKg" ? "kg" : ""}</dd></div>)}</dl> : <p>공개된 인상착의 정보가 없어요.</p>;
}
